__turbopack_context__.v({
  "cardContent": "Sh6D1W_cardContent",
  "cardTitle": "Sh6D1W_cardTitle",
  "cardUpdatedAt": "Sh6D1W_cardUpdatedAt",
  "chartCard": "Sh6D1W_chartCard",
  "chartSection": "Sh6D1W_chartSection",
  "contentRow": "Sh6D1W_contentRow",
  "dashboard": "Sh6D1W_dashboard",
  "errorState": "Sh6D1W_errorState",
  "loading": "Sh6D1W_loading",
  "mapWarning": "Sh6D1W_mapWarning",
  "sqlMeta": "Sh6D1W_sqlMeta",
  "sqlPanel": "Sh6D1W_sqlPanel",
  "sqlSection": "Sh6D1W_sqlSection",
  "tablePanel": "Sh6D1W_tablePanel",
  "tableSection": "Sh6D1W_tableSection",
  "updatedAt": "Sh6D1W_updatedAt",
});
